/** Formatting shared by the household plan's components (issue #32). */

export const money = (v: number | null | undefined, currency = 'CAD') =>
  new Intl.NumberFormat('en-CA', { style: 'currency', currency, maximumFractionDigits: 0 }).format(Number(v ?? 0));

export const compact = (v: number) =>
  new Intl.NumberFormat('en-CA', { notation: 'compact', maximumFractionDigits: 1 }).format(v);

export const compactMoney = (v: number, currency = 'CAD') =>
  new Intl.NumberFormat('en-CA', { style: 'currency', currency, notation: 'compact', maximumFractionDigits: 1 }).format(v);

export const pct = (fraction: number, digits = 1) => `${(fraction * 100).toFixed(digits)}%`;

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "Feb 2052" from "2052-02-22" (calendar date, no timezone shift). */
export const monthYear = (ymd: string | undefined) => {
  if (!ymd) return '';
  const [y, m] = ymd.slice(0, 10).split('-').map(Number);
  return m ? `${MONTHS[m - 1]} ${y}` : ymd;
};

export const CLASS_LABELS: Record<string, string> = {
  equity: 'Equity', fixed_income: 'Fixed income', cash: 'Cash', crypto: 'Crypto',
  commodity: 'Commodity', private: 'Private', other: 'Other / unclassified',
};
